import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import NotchedOutline from '@mui/material/OutlinedInput/NotchedOutline';

const LabelledOutline = ({ id, label, children }) => {
  return (
    <div style={{ position: 'relative', marginTop: '8px' }}>
      <InputLabel
        htmlFor={id}
        variant="outlined"
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
          borderColor: 'red',
        }}
        shrink
      >
        {label}
      </InputLabel>
      <div style={{ position: 'relative' }}>
        <div
          id={id}
          style={{
            padding: '18.5px 14px',
            borderRadius: '4px',
            borderColor: '#263238',
          }}
        >
          {children}
          <NotchedOutline notched label={id} />
        </div>
      </div>
    </div>
  );
};
export default LabelledOutline;
